import React, {ReactElement} from 'react';
import {DeviceType} from '../../../incase-domain/common/DeviceType.enum';
import {ICalculator, ICalculatorField} from '../../../incase-domain/elements/calculator';

interface CalculatorDisplayProps {
    calculator: ICalculator;
    inputState?: {[key: string]: string};
    result?: number;
    onInputChange?: (value: string, field: ICalculatorField) => void;
    readOnly?: boolean;
    device?: DeviceType;
}

function CalculatorDisplay({
    calculator,
    inputState = {},
    result,
    onInputChange,
    readOnly = false,
    device = DeviceType.DESKTOP,
}: CalculatorDisplayProps): ReactElement {
    return (
        <div className={`c-calculator ${device === DeviceType.MOBILE && 'c-calculator--mobile'}`}>
            <div className="c-calculator__header">{calculator?.header}</div>

            <div>
                {calculator?.fields?.map((field) => (
                    <div key={field._id} className="c-calculator__field">
                        <label className="c-calculator__field_label" htmlFor={`calculator-field-${field._id}`}>
                            {field.label}:
                        </label>
                        <input
                            type="text"
                            id={`calculator-field-${field._id}`}
                            readOnly={readOnly}
                            disabled={readOnly}
                            className="c-calculator__field_input"
                            value={inputState[field.name] || ''}
                            onChange={(e) => onInputChange && onInputChange(e.target.value, field)}
                        />
                    </div>
                ))}
            </div>

            <div className="c-calculator__field c-calculator__field--result">
                <label className="c-calculator__field_label" htmlFor={`calculator-result-${calculator._id}`}>
                    {calculator.resultLabel}:
                </label>
                <input
                    type="text"
                    id={`calculator-result-${calculator._id}`}
                    className="c-calculator__field_input"
                    value={result ?? ''}
                    readOnly
                />
            </div>
        </div>
    );
}

export default CalculatorDisplay;
